
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchOutLaborGrid extends Serenity.EntityGrid<BranchOutLaborRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchOutLabor'; }
        protected getDialogType() { return BranchOutLaborDialog; }
        protected getIdProperty() { return BranchOutLaborRow.idProperty; }
        protected getInsertPermission() { return BranchOutLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchOutLaborRow.localTextPrefix; }
        protected getService() { return BranchOutLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}